module.exports = __webpack_public_path__ + "static/media/rosaDosVentos.9ac49128.png";